// extracted by mini-css-extract-plugin
export var underlinedLink = "_sy-0";